define('lib/Podio.Router.Content',['require','underscore','crossroads','lib/Podio.Config','lib/Podio.Event','lib/Podio.Logger','lib/Podio.DynamicContentRoutes','lib/getMatchedRouteParams','controllers/Podio.Controllers.DynamicContentManager'],function (require) {

  var _ = require('underscore');
  var crossroads = require('crossroads');
  var podioConfig = require('lib/Podio.Config');
  var podioEvent = require('lib/Podio.Event');
  var podioLogger = require('lib/Podio.Logger');
  var dynamicRoutes = require('lib/Podio.DynamicContentRoutes');
  var getMatchedRouteParams = require('lib/getMatchedRouteParams');

  var DynamicContentManager = require('controllers/Podio.Controllers.DynamicContentManager');

  var router, contentManager;
  var hasRouted = false;
  var ENABLE_LOGGING = false;

  var initOnce = _.once(function() {
    router = crossroads.create();
    // we don't want crossroads to prevent triggering the same route twice in a row
    router.ignoreState = true;

    _registerRoutes();

    router.routed.add(function(optionsOrRequest, requestOrData, dataOrNothing) {
      // let's not retrigger a route if we already have one
      if (!hasRouted) {
        // if we have passed along the options hash the request is dynamic and arguments are options, request, data
        if (!_.isUndefined(dataOrNothing) && _.isObject(optionsOrRequest) && !_.isUndefined(optionsOrRequest.renderType)) {
          log('routed', requestOrData);
          _onRouteMatched(optionsOrRequest, requestOrData, dataOrNothing);
        } else {
          // arguments are option, request, undefined
          log('routed', optionsOrRequest);
          _onRouteMatched({}, optionsOrRequest, requestOrData);
        }

        hasRouted = true;
      }
    });

    router.bypassed.add(function(options, request) {
      var wasRouted = hasRouted;

      hasRouted = false;
      log('bypassed');

      if (wasRouted && !_.isUndefined(contentManager)) {
        contentManager.handleUnsupportedContent(_.extend(options, { prevURL: router._prevMatchedRequest })).fail(function() {
          // unsupported content won't be loaded because user has rejected
          // leaving the overlay
          hasRouted = true;
        });
      }
    });

    window.addEventListener('popstate', onHistoryStateChanged);
  });

  function _onRouteMatched(options, request, data) {
    options = options || {};
    options.routeData = {
      pattern: data.route._pattern,
      url: request,
      params: getMatchedRouteParams(data)
    };

    contentManager = DynamicContentManager.getInstance({ navigatorDelegate: _getDelegate() });
    contentManager.loadContent(options);
  }

  function _getAllRoutes() {
    return _.keys(dynamicRoutes) ;
  }

  function _registerRoutes() {
    _.each(_getAllRoutes(), function(route) {
      router.addRoute(route);
    });
  }

  function _getPath(path) {
    // remove the root path
    if (path.indexOf(podioConfig.base_domain) !== -1) {
      path = path.substr(path.indexOf(podioConfig.base_domain) + podioConfig.base_domain.length);
    }

    return path;
  }

  function _getDelegate() {
    return {
      navigateTo: function(url) {
        navigate(url);
      }
    };
  }

  function navigate(url, options) {
    if (!url) {
      return;
    }

    options = options || {};
    options.previousURL = document.location.toString();

    router.parse(_getPath(url), [options]);

    if (hasRouted && !_.isUndefined(contentManager)) {
      contentManager.localNavigate(url, options);
    } else {
      history.pushState({ dynamic: true }, '', url);
    }
  }

  function onHistoryStateChanged(e) {
    var url = document.location.toString();
    var hashLength = document.location.hash.length;

    // remove the hash part from the URL
    if (hashLength > 0) {
      url = url.slice(0, -hashLength);
    }

    // if popstate event has been triggered on page load (Webkit browsers do that), ignore it
    if (!_.isNull(e.state) || !_.isUndefined(contentManager)) {
      router.parse(_getPath(url), [{ fromPopState: true, renderType: 'overlay' }]);
    }
  }

  function onDomReady() {
    var url = document.location.toString();

    router.parse(_getPath(url), [{ permalink: true, renderType: 'content-replacement' }]);
  }

  function log() {
    var args = _.toArray(arguments);

    args.unshift('contentRouter:');

    if (ENABLE_LOGGING) {
      podioLogger.log.apply(this, args);
    }
  }

  initOnce();

  podioEvent.bind(podioEvent.Types.init, onDomReady);

  return {
    navigate: navigate
  };

});

